<template>
  <div class="statistics">
    <div class="df statistics-box"  :style="{fontSize: fontsize + 'px'}">
      <div 
        v-for="(item, index) in summaps" 
        :key="index" 
        class="df-c"
        :class="{'status-alert': ['待单','空闲'].includes(item.macStatus)}"
      >
        <div class="left">
          <div class="title">
            <div class="titlen">{{ item.MachineNo }}</div>
            <div class="titlem">{{ item.Processor1 }}</div>
          </div>
          <div :class="`title title-${item.macStatus}`">
            <div class="titlen">{{ item.macStatus }}</div>
            <div class="titlem">{{ formatTimeDifference(item.ltime) }}</div>
          </div>
          <div class="title">
            <div class="titlen">{{item.PartNu?item.PartNu.slice(-safePnlen):item.PartNu }}</div>
            <div class="titlem">共{{ Number(item.PG).toLocaleString() }}款</div>
          </div>
        </div>
        <div class="right">
          <img src="@/assets/images/bigscreenSales/statistics_line.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/js/config'
import { speak } from '@/utils/speech';

export default {
  name: 'Statistics',
  data() {
    return {
      maclist: [],
      summaps: [{
        // 初始化数据
        title: '月初留存',
        pcs: 0,
        sumpri: 0,
        pcsunite: '件',
        priunite: '万元',
        pcsuniteWidth: '30px',
        pcspretxt: '',
        pripretxt: '',
        pcsadd: 0,
        priadd: 0,
        Department: '',
        MachineNo: '',
        Processor1: '',
        PartNu: '',
        St1: '',
        ETTime: 0,
        Dishours: 0,
        Dis1: 0,
        Status: 0,
        macStatus: '',
        PG: 0,
        ED1: '',
        DET: '',
        StatusStr: '',
        STA: 0
      }],
      compid: -1,
      dept: '',
      requestTimer: null,
      requestpcs: 0,
      requestUrl: '',
      manormac: 0,
      requestmac: null,
      maclen: 0,
      macrun: 0,
      maccurrun: 0,
      classst: '8:00',
      speakstr: '',
      lastSpeakTime: 0,
      hasIdleMachines: false,
      normalRefreshInterval:10 * 60 * 1000, // 5分钟
      idleRefreshInterval:2* 60 * 1000, // 1分钟
      pnlen:11,
      fontsize:16
    }
  },
  created() {
    this.requestUrl = window.localStorage.getItem('requestUrl');
    this.getsumaa();
    this.pnlen = Number(window.localStorage.getItem('bsmpnlen')) || 11;
    var fnt = window.localStorage.getItem('bsmisfontsize')
      if(fnt > 10) {
        this.fontsize = fnt
      }
      else
      this.fontsize = 16
  },
  computed: {
  safePnlen() {
    return Math.abs(parseInt(this.pnlen)) || 11; // 确保是正整数，默认 11
  }
},
  methods: {
    getsumaa() {
      this.dept = window.localStorage.getItem('bsmdept');
      this.compid = window.localStorage.getItem('bsmcompid');
      let mm = window.localStorage.getItem('bsmmanormac');
      this.manormac = (mm == '' || mm == null) ? 0 : mm;

      this.classst = window.localStorage.getItem('bsmdayst') || '8:00';
      
      this.axios({
        method: 'post',
        url: `${this.requestUrl}/admin.php/Bigsreen/macstatusfun?compid=${this.compid}&mac=${this.manormac}&dept=${this.dept}&dayst=${this.classst}`
      })
      .then((Response) => {
        let clio = JSON.parse(Response.data);
        if(clio.length>0)
        {
          this.maclist = clio;
          this.maclen = clio.length;
        
          this.macrun = parseInt(this.maclen / 9);
          if (this.macrun * 9 < this.maclen) this.macrun++;

          this.macrun--;
          this.summaps = this.maclen < 10 ? clio : this.maclist.slice(0, 9);

          // 检测空闲机台
          this.hasIdleMachines = clio.some(item => 
            ["空闲", "待单"].includes(item.macStatus)
          );

          // 准备语音内容
          this.speakstr = "";
          if (this.hasIdleMachines) {
            for (const itm of clio) {
              if (["空闲", "待单"].includes(itm["macStatus"])) {
                this.speakstr += this.manormac == 1 ? 
                  ` ${itm["Processor1"]}` : 
                  ` ${itm["MachineNo"]}`;
              }
            }
            // 检测到空闲机台立即播报
            // speak(this.speakstr + (this.manormac == 1 ? "空闲" : "停机"));
          this.playSpeech()
            this.lastSpeakTime = Date.now();
          }
          // 调整刷新频率
          this.adjustRefreshRate();
        }
      })
      .catch(error => {
        // console.error("请求失败:", error);
        // 失败后按正常频率重试
        this.hasIdleMachines = false;
        this.adjustRefreshRate();
      });
    },
    playSpeech() {
        if (this.speakstr) {
            // 添加延迟确保DOM加载完成
            setTimeout(() => {
                speak(this.speakstr+ (this.manormac == 1 ? "空闲" : "停机"));
            }, 1000);
            
            // Android特殊处理
            if (this.isAndroid()) {
                this.$nextTick(() => {
                    const event = new Event('click');
                    document.dispatchEvent(event);
                });
            }
        }
    },
    
    isAndroid() {
        return navigator.userAgent.toLowerCase().indexOf('android') > -1;
    },

    adjustRefreshRate() {
      clearInterval(this.requestTimer);
      const interval = this.hasIdleMachines 
        ? this.idleRefreshInterval 
        : this.normalRefreshInterval;
      
      this.requestTimer = setInterval(() => {
        this.getsumaa();
      }, interval);
    },

    formatTimeDifference(timePoint) {
      if (!timePoint) return "无数据";
      let aa = new Date(timePoint);
      if (isNaN(aa.getTime())) return "无效时间";
      
      const diff = new Date() - aa;
      const diffHours = Math.floor(diff / (1000 * 60 * 60));
      const diffMinutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      return `${diffHours}时${diffMinutes}分`;
    }
  },
  mounted() {
    // 每分钟检查语音播报
    this.speakTimer = setInterval(() => {
      if (this.hasIdleMachines && this.speakstr) {
        const now = Date.now();
        if (now - this.lastSpeakTime >= 60000) {
          speak(this.speakstr + (this.manormac == 1 ? "空闲" : "停机"));
          this.lastSpeakTime = now;
        }
      }
    }, 10000); // 每10秒检查一次

    // 分页定时器
    this.requestmac = setInterval(() => {
      if (this.maclen < 1) return; // No data to display
      
      // Calculate total pages needed (ceil(maclen/9))
      const totalPages = Math.ceil(this.maclen / 9);
      
      // Move to next page, wrap around if needed
      this.maccurrun = (this.maccurrun + 1) % totalPages;
      
      // Calculate start and end indices
      let start = this.maccurrun * 9;
      let end = start + 9;
      
      // If we're at the last page and don't have enough items
      if (end > this.maclen) {
        // Calculate how many items we're short
        const shortBy = end - this.maclen;
        // Adjust start to include previous items if available
        start = Math.max(0, start - shortBy);
      }
      
      // Get the slice of data
      this.summaps = this.maclist.slice(start, Math.min(end, this.maclen));
    }, 20 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.speakTimer);
    clearInterval(this.requestTimer);
    clearInterval(this.requestmac);
  }
}
</script>

<style scoped lang="less">
.statistics {
  width: 1845px;
  height: 173px;
  margin: 0 auto;
  background-image: url('../../../assets/images/bigscreenSales/statistics.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  
  .statistics-box {
    justify-content: space-evenly;
    align-items: center;
    height: 173px;
    
    > div {
      transition: all 0.3s ease;
      
      &.status-alert {
        .titlen, 
        .titlem,
        .title .titlen,
        .title .titlem {
          background: linear-gradient(180deg, #FF0000 0%, #FF4500 100%) !important;
          -webkit-background-clip: text !important;
          -webkit-text-fill-color: transparent !important;
          background-clip: text !important;
          text-fill-color: transparent !important;
        }
      }
    }
  }
  
  .left {
    margin-right: 12px;
    
    .title {
      display: flex;
      justify-content: space-between;
      
      .titlen, .titlem {
        height: 26px;
        margin-bottom: 12px;
        padding-right: 18px;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 26px;
        background: linear-gradient(180deg, #2dcdff 37.5%, #2ffff4 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
      
      .titlen {
        text-align: left;
      }
      
      .titlem {
        text-align: right;
      }
    }
  }
  
  .right img {
    width: 3px;
    height: 101px;
  }
  
  .title-加工中 .titlen {
    background: linear-gradient(180deg, #2dcdff 37.5%, #2ffff4 100%);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/workroomdp/components/Statistics.vue